import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { AC_PAGE_MAX_INLINE_SIZE } from 'academy-navigation-lib/components/ACPage/ACPage';
import { ACADEMY_ONBOARDING_SECTION_SCROLL_MARGIN } from '../constants/sectionAnchors';
import { jsx as _jsx } from "react/jsx-runtime";
const OnboardingSectionLayout = ({
  backgroundColor,
  children,
  id,
  paddingBlockStart,
  paddingBlockEnd
}) => {
  const {
    isMobile,
    isDesktopNavbar
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: backgroundColor,
    id: id,
    paddingBlockEnd: paddingBlockEnd !== null && paddingBlockEnd !== void 0 ? paddingBlockEnd : isDesktopNavbar ? '1100' : '600',
    paddingBlockStart: paddingBlockStart !== null && paddingBlockStart !== void 0 ? paddingBlockStart : isMobile ? '400' : isDesktopNavbar ? '1100' : '600',
    paddingInline: isDesktopNavbar ? '1100' : '400',
    scrollMarginBlockStart: id ? ACADEMY_ONBOARDING_SECTION_SCROLL_MARGIN : undefined,
    children: /*#__PURE__*/_jsx(View, {
      marginInline: "auto",
      maxInlineSize: `${AC_PAGE_MAX_INLINE_SIZE}px`,
      children: children
    })
  });
};
export default OnboardingSectionLayout;